<template>
  <div class="payment-success-page">
    <div v-if="loading" class="loading-container">
      <div class="loading-text">正在验证订单信息...</div>
    </div>
    <div v-else-if="!isAuthorized" class="error-container">
      <div class="error-icon">⚠️</div>
      <div class="error-text">{{ errorMessage }}</div>
      <button class="return-button" @click="handleReturn">返回</button>
    </div>
    <div v-else class="payment-success-container">
      <!-- 顶部信息区域 -->
      <div class="payment-success-header">
        <div class="header-left">
          <span>您的订单已付款成功!</span>
        </div>
        <div class="header-right">
          <div class="paid-amount">已付款 {{ orderAmount }}元</div>
          <div class="order-info">订单编号: {{ paymentOrderNo }}</div>
        </div>
      </div>
      
      <!-- 主内容区域 -->
      <div class="payment-success-content">
        <!-- 成功图标 -->
        <div class="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="38" fill="#52c41a" />
            <path d="M25 40 L35 50 L55 30" stroke="white" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        
        <!-- 成功文字 -->
        <div class="success-text">支付成功</div>
        
        <!-- 支付详情 -->
        <div class="payment-details">
          <div class="detail-item">订单金额 {{ orderAmount }}元</div>
          <div class="detail-item" v-if="transactionNo">交易流水号 {{ transactionNo }}</div>
        </div>
        
        <!-- 返回按钮 -->
        <button class="return-button" @click="handleReturn">返回</button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "payReturn",
  data() {
    return {
      paymentOrderNo: "",
      orderAmount: "0.00",
      creditedAmount: "0.00",
      transactionNo: "",
      loading: true,
      isAuthorized: false,
      errorMessage: "",
      checkOrderTimer: null,
      requestInterval: 5000,
    };
  },
  created() {
    this.verifyAndLoadPaymentInfo();
  },
  beforeDestroy() {
    this.clearCheckOrderTimer();
  },
  methods: {
    verifyAndLoadPaymentInfo() {
      const userToken = Cookies.get("view_userToken");
      if (!userToken) {
        this.loading = false;
        this.isAuthorized = false;
        this.errorMessage = "请先登录后再查看订单信息";
        setTimeout(() => {
          this.$router.push({ path: '/login' });
        }, 2000);
        return;
      }

      const orderNo = this.$route.query.order_no || this.$route.query.out_trade_no;
      if (!orderNo) {
        this.loading = false;
        this.isAuthorized = false;
        this.errorMessage = "订单号不能为空";
        return;
      }

      this.checkOrder(orderNo);
    },

    payReturn() {
      const userToken = Cookies.get("view_userToken");
      if (!userToken) {
        this.loading = false;
        this.isAuthorized = false;
        this.errorMessage = "登录信息已失效";
      }
      const url = this.$root.commonPreUrl + "/index/payReturn";
    },
    checkOrder(orderNo) {
      const userToken = Cookies.get("view_userToken");
      if (!userToken) {
        this.loading = false;
        this.isAuthorized = false;
        this.errorMessage = "登录信息已失效";
        this.clearCheckOrderTimer(); // 清除定时器
        setTimeout(() => {
          this.$router.push({ path: '/login' });
        }, 2000);
        return;
      }

      const url = this.$root.commonPreUrl + "/index/checkOrder";
      let params = {
        order_no: orderNo,
      };

      axios.post(url, params, {
          headers: {
            Authorization: "Bearer " + userToken,
          },
        })
        .then((response) => {
          const resd = response.data;
        
          if (resd.code == 200) {
            this.loading = false;
            this.clearCheckOrderTimer();
            
            if (!resd.data) {
              this.isAuthorized = false;
              this.errorMessage = "订单信息不存在";
              return;
            }
            this.isAuthorized = true;
            this.setPaymentData(resd.data, orderNo);
            
            // if (this.$root && this.$root.getUserBalance) {
            //   this.$root.getUserBalance();
            // }
            
          } else {
            this.loading = false;
            this.clearCheckOrderTimer();
            this.isAuthorized = false;
            if (resd.code == 201) {
              this.startCheckOrderLoop(orderNo);
              return;
            } else {
              this.errorMessage = resd.message || "订单不存在或无权访问";
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.isAuthorized = false;
          this.errorMessage = "订单验证失败，请稍后重试";
          this.clearCheckOrderTimer(); 
        });
    },
    // 开始循环请求
    startCheckOrderLoop(orderNo) {
      this.clearCheckOrderTimer();
      
      this.checkOrderTimer = setTimeout(() => {
        this.checkOrder(orderNo);
      }, this.requestInterval);
    },
    // 清除定时器
    clearCheckOrderTimer() {
      if (this.checkOrderTimer) {
        clearTimeout(this.checkOrderTimer);
        this.checkOrderTimer = null;
      }
    },
    setPaymentData(data, orderNo) {
      console.log(data);
      const amount = data.total_amount || 0;
      const formattedAmount = typeof amount === 'number' ? amount.toFixed(2) : parseFloat(amount || 0).toFixed(2);
      
      this.paymentOrderNo = orderNo || data.order_no;
      this.transactionNo = data.trade_no || "";
      
      if (data.order_amount) {
        this.orderAmount = parseFloat(data.order_amount || 0).toFixed(2);
      } else {
        this.orderAmount = formattedAmount;
      }
      
    },
    handleReturn() {
      // 返回充值中心
      this.$router.push({ path: '/cwmx/czzx' });
    }
  },
};
</script>

<style scoped>
.payment-success-page {
  /* min-height: 100vh; */
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.payment-success-container {
  background-color: white;
  width: 100%;
  max-width: 900px;
  min-height: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.payment-success-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  /* margin-bottom: 40px; */
}

.header-left {
  /* flex: 1; */
  color: #333;
  font-size: 14px;
}

.header-right {
  text-align: right;
}

.paid-amount {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.order-info {
  font-size: 12px;
  color: #666;
}

.payment-success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 400px;
}

.success-icon {
  margin-bottom: 30px;
}

.success-icon svg {
  display: block;
}

/* 成功文字 */
.success-text {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-bottom: 40px;
}

/* 支付详情 */
.payment-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-bottom: 50px;
  width: 100%;
  max-width: 400px;
}

.detail-item {
  font-size: 16px;
  color: #333;
  width: 100%;
  text-align: center;
}

.return-button {
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

/* 加载状态 */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.loading-text {
  font-size: 18px;
  color: #666;
}

/* 错误状态 */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px 20px;
}

.error-icon {
  font-size: 50px;
  /* margin-bottom: 20px; */
}

.error-text {
  font-size: 18px;
  color: #ff4d4f;
  margin-bottom: 20px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/views/cwmx/payReturn/index.vue